export const isConnectionEnd = (connection, direction = 'forward') => {
  if (!connection || !connection.pageInfo) {
    return true
  }
  const { pageInfo: { hasNextPage, hasPreviousPage } } = connection

  return direction === 'forward' ? !hasNextPage : !hasPreviousPage
}

export const pluckNodes = connection =>
  !connection || !connection.edges
    ? []
    : connection.edges.map(edge => edge.node)



// WEBPACK FOOTER //
// ./src/utils/relay.js